
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { COMMON_IMPORTS } from "../../global-misc/common-imports";
import { CrudTreatmentFacade, CrudTreatmentMode, CrudTreatmentState } from "./crud-treatment.facade";
import { DropdownModule } from "primeng/dropdown";
import { CalendarModule } from "primeng/calendar";
import { DividerModule } from "primeng/divider";
import { Observable } from "rxjs";

@Component({
    standalone: true,
    selector: "app-crud-treatment",
    imports: [...COMMON_IMPORTS, DropdownModule, CalendarModule, DividerModule],
    templateUrl: "./crud-treatment.template.html",
})
export class CrudTreatmentComponent implements OnInit {
    @Input() orgId!: string;
    @Input() patientId!: string;
    @Input() treatmentId?: string;
    @Input() crudMode!: CrudTreatmentMode;

    private formSubmitEvent = new EventEmitter<null>();
    @Output() onFormSubmit: Observable<null> = this.formSubmitEvent.asObservable();

    public state: CrudTreatmentState = this.facade.EMPTY_UI_STATE;

    public constructor(private readonly facade: CrudTreatmentFacade) { }

    public ngOnInit() {
        this.facade.crudTreatmentState$.subscribe((_state: CrudTreatmentState) => {
            this.state = _state;
        });

        this.facade.begin(this.crudMode, this.orgId, this.patientId, this.treatmentId);
    }

    public getTodaysDate(): Date {
        return new Date();
    }

    public async submitForm() {
        await this.facade.submitForm();
        this.formSubmitEvent.emit();
    }
}